import { render, staticRenderFns } from "./LoyaltyQuestions.vue?vue&type=template&id=7dcad2fa"
import script from "./LoyaltyQuestions.vue?vue&type=script&lang=js"
export * from "./LoyaltyQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports